import {
  Avatar,
  IconButton,
  Menu,
  Divider,
  useTheme,
  Stack,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useAppSelector } from "../../store/hooks";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../../hooks/useLogout";
import { MenuHeader } from "./partials/MenuHeader";
import { MenuLink } from "./partials/MenuLink";

export const DropdownMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { user } = useAppSelector((state) => state.user);

  const theme = useTheme();
  const navigate = useNavigate();

  const { logout, loading: loggingOut } = useLogout();

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (href: string) => () => {
    navigate(href);
    handleClose();
  };

  const handleLogout = async () => {
    await logout();
    handleClose();
  };

  return (
    <Stack justifyContent="center" alignItems="center">
      <IconButton
        disableRipple
        onClick={handleOpen}
        sx={{ width: "auto", height: "auto", p: 0 }}
      >
        <Avatar
          src={user?.photoName}
          alt="User avatar"
          sx={{ width: 40, height: 40 }}
        />
        <ArrowDropDownIcon />
      </IconButton>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ zIndex: theme.zIndex.appBar + 1 }}
        slotProps={{
          paper: {
            sx: { width: 280, borderRadius: 1, boxShadow: theme.shadows[1] },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuHeader user={user} />
        <Divider sx={{ my: 1 }} />
        <MenuLink
          label="Account"
          onClick={handleNavigation("/account")}
          disabled={loggingOut}
          renderIcon={(props) => <PersonOutlineOutlinedIcon {...props} />}
        />
        <MenuLink
          label="Settings"
          onClick={handleNavigation("/settings")}
          disabled={loggingOut}
          renderIcon={(props) => <SettingsOutlinedIcon {...props} />}
        />
        <MenuLink
          label="Subscriptions"
          onClick={handleNavigation("/account/subscriptions")}
          disabled={loggingOut}
          renderIcon={(props) => <DescriptionOutlinedIcon {...props} />}
        />
        <Divider />
        <MenuLink
          label="Sign Out"
          loading={loggingOut}
          onClick={handleLogout}
          renderIcon={(props) => <LogoutIcon {...props} />}
        />
      </Menu>
    </Stack>
  );
};

export default DropdownMenu;
